import { RootState } from '../store';

import { AuthTokenState } from './types';

export const selectAuthToken = (state: RootState): AuthTokenState => state.authToken; // access token jwt binus
export const selectAuthTokenMyDashboard = (state: RootState): string =>
  state.authToken.myDashboardToken;
export const selectAuthTokenAzureAD = (state: RootState): string => state.authToken.azureADToken; // access token jwt azure ad
export const selectAuthTokenRefresh = (state: RootState): string => state.authToken.refreshToken; // refresh token binus
